import { render, staticRenderFns } from "./YA_webEmpty.vue?vue&type=template&id=08b83379&scoped=true"
import script from "./YA_webEmpty.vue?vue&type=script&lang=js"
export * from "./YA_webEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b83379",
  null
  
)

export default component.exports